import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {
  ReactPlugin,
  withAITracking,
  AppInsightsContext,
} from '@microsoft/applicationinsights-react-js';
import { appInsightsConnectionString } from '../../tools';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: appInsightsConnectionString,
    enableAutoRouteTracking: false, // recommended by MS, use on RR6
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAjaxPerfTracking: true,
    isBrowserLinkTrackingEnabled: true,
    extensions: [reactPlugin],
  },
});

appInsights.loadAppInsights();

const AzureAppInsights: React.FC = ({ children }) => {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
  );
};

export default withAITracking(reactPlugin, AzureAppInsights);
